import styled, { css } from 'styled-components';
import { PageWrapper } from '@ardoq/page-layout';
import { captureModeControlStyles } from '@ardoq/export/captureMode';

export const ReportPageWrapper = styled(PageWrapper)<{
  $isCaptureMode: boolean;
}>`
  ${({ $isCaptureMode }) =>
    $isCaptureMode &&
    css`
      flex: none;
      width: fit-content;
      min-width: 100%;
      height: fit-content;
      ${captureModeControlStyles}
    `}
`;
